export default {
      id: "filterNone-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#filterNone-usage",
      toString: function () {
        return this.url;
      }
    }